<ng-container *ngIf="isChangeRequest; else default">
  <ng-container *ngIf="!showDiff(fieldName); else diff">
    {{ valueFn ? valueFn(getFieldToDisplay(fieldName)) : getFieldToDisplay(fieldName) }}
  </ng-container>
</ng-container>

<ng-template
  #diffTemplate
  let-fieldName="fieldName"
  let-valueFn="valueFn">
  <span class="change-request-diff">
    <span
      class="change-request-old"
      [ngClass]="{ 'change-request-old-highlight': highlightColors }"
      >{{ valueFn ? valueFn(changes?.[fieldName]?.old) : changes?.[fieldName]?.old }}</span
    >
    <span
      class="change-request-new"
      [ngClass]="{ 'change-request-new-highlight': highlightColors }"
      >{{ valueFn ? valueFn(changes?.[fieldName]?.new) : changes?.[fieldName]?.new }}</span
    >
  </span>
</ng-template>

<ng-template #diff>
  <ng-container *ngTemplateOutlet="diffTemplate; context: { fieldName, valueFn }"> </ng-container>
</ng-template>

<ng-template #default>
  {{ valueFn ? valueFn(getFieldValue()) : getFieldValue() }}
</ng-template>
